/* Dobra Ulga: dodatki do theme.js (osobny plik, żeby nie nadpisywać theme.js). */
(() => {
  /* Karta produktu z wariantami: "Dodaj" rozwija listę wariantów, klik w wariant dodaje do koszyka (data-quick-add w theme.js). */
  const setOpen = (box, open) => {
    box.querySelector('[data-card-variant-list]').hidden = !open;
    const btn = box.querySelector('[data-card-variants-toggle]');
    btn.hidden = open;
    btn.setAttribute('aria-expanded', String(open));
  };
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-card-variants-toggle]');
    const current = e.target.closest('[data-card-variants]');
    document.querySelectorAll('[data-card-variants]').forEach((box) => {
      if (box === current) { if (toggle) setOpen(box, true); return; }
      setOpen(box, false);
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-card-variants]').forEach((box) => {
      setOpen(box, false);
    });
  });
})();

/* Zestawy na karcie produktu: karuzela (strzałki, przewijanie palcem) i dodanie obu produktów naraz. */
(() => {
  document.querySelectorAll('[data-psets]').forEach((root) => {
    const track = root.querySelector('[data-psets-track]');
    const prev = root.querySelector('[data-psets-prev]');
    const next = root.querySelector('[data-psets-next]');
    if (!track || !prev || !next) return;
    const step = () => {
      const slide = track.querySelector('.psets__slide');
      return slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    const sync = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-set-add]');
    if (!btn) return;
    e.preventDefault();
    const items = btn.dataset.setAdd.split(',').map((id) => ({ id: Number(id), quantity: 1 }));
    const label = btn.textContent;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    btn.textContent = 'Dodaję…';
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Nie udało się dodać zestawu.');
      const drawer = document.querySelector('cart-drawer');
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      if (drawer && typeof drawer.render === 'function') { drawer.render(data.sections, cart.item_count); drawer.open(); }
      else window.location.href = root + 'cart';
    } catch (err) {
      window.alert(err.message || 'Nie udało się dodać zestawu.');
    } finally {
      if (btn.isConnected) { btn.disabled = false; btn.textContent = label; }
    }
  });
})();


(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-du-announce]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const items = [...root.querySelectorAll('.announce__item')];
      const button = root.querySelector('[data-du-announce-pause]');
      if (items.length < 2 || !button) return;
      let active = 0;
      let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const sync = () => {
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      };
      button.addEventListener('click', () => { paused = !paused; sync(); });
      sync();
      const timer = setInterval(() => {
        if (!root.isConnected) { clearInterval(timer); return; }
        if (paused || document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
        items[active].hidden = true;
        active = (active + 1) % items.length;
        items[active].hidden = false;
      }, Number(root.dataset.interval) || 5000);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
